module.exports = __webpack_public_path__ + "img/Download-bursary.3a942d5f.svg";